import FormMenuItem from "./FormMenuItem"
import styles from "../../../styles/Participant-Employment.module.css"
import { Button } from "primereact/button"
import { careerProfileLabels } from "../Types/careerProfileLabels"
const FormMenu = ({
  activeForm,
  setActiveForm,
  formik,
  closeForm,
  saveData,
  editCareerProfile,
  extraEducationSections,
  loading,
}) => {
  return (
    <div className={styles.careerProfile_menu}>
      <div>
        {(extraEducationSections
          ? Object.entries(careerProfileLabels)
          : Object.entries(careerProfileLabels).filter(
              (f) =>
                f[0] !== "pastEducationExperiences" &&
                f[0] !== "plansForSchoolAndTraining"
            )
        ).map((f) => {
          return (
            <FormMenuItem
              key={f[0]}
              activeForm={activeForm}
              setActiveForm={setActiveForm}
              label={f[1].title}
              value={f[1].title}
            />
          )
        })}
      </div>
      <div style={{ marginBottom: "15px" }}>
        <Button
          label={`${editCareerProfile ? "Edit" : "Create"} career profile`}
          className={styles.button}
          icon={loading ? "pi pi-spin pi-spinner" : ""}
          iconPos="right"
          disabled={loading}
          type="button"
          onClick={() => {
            saveData()
          }}
        />
        <Button
          label="Cancel"
          className={`${styles.button} ${styles.button_secondary}`}
          onClick={() => {
            formik.resetForm()
            closeForm()
          }}
          disabled={loading}
        />
      </div>
    </div>
  )
}
export default FormMenu
